document.addEventListener('DOMContentLoaded', ()=>{
    let inputs = document.querySelectorAll('.jsNumberField');

    for (let index = 0; index < inputs.length; index++) {
        const input = inputs[index];
        const parent = input.closest('.input-number');
        const add = parent.querySelector('.jsNumberAdd');
        const sub = parent.querySelector('.jsNumberSub');
        const min = Number(input.getAttribute('data-min'));
        const max = Number(input.getAttribute('data-max'));

        add.addEventListener('click', () =>{
            if(input.value < max){
                input.value++
            }
            check()
        })
        
        sub.addEventListener('click', () =>{
            if(input.value > min){
                input.value--
            }
            check()
        })

        function check(){
            if(input.value == max){
                add.classList.add('is-disabled')
            } else{
                add.classList.remove('is-disabled')
            }

            if(input.value == min){
                sub.classList.add('is-disabled')

                if(parent.closest('.card-product')){
                    parent.closest('.card-product').classList.remove('is-added')
                } else if(parent.closest('.product')){
                    parent.closest('.product').classList.remove('is-added')
                }
            } else{
                sub.classList.remove('is-disabled')
            }
    
            input.size = input.value.length
        }
    }
})